'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_ui_Inputs$$anon$3(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_ui_Inputs$$anon$3 as $c_Lpresto_ui_Inputs$$anon$3 };
$p = $c_Lpresto_ui_Inputs$$anon$3.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_ui_Inputs$$anon$3;
/** @constructor */
function $h_Lpresto_ui_Inputs$$anon$3() {
}
export { $h_Lpresto_ui_Inputs$$anon$3 as $h_Lpresto_ui_Inputs$$anon$3 };
$h_Lpresto_ui_Inputs$$anon$3.prototype = $p;
$p.bN = (function(str) {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success((((str === "sim") || (str === "yes")) || (str === "true")));
});
$p.cAK = (function(value) {
  return (value ? new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success("sim") : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success("n\u00e3o"));
});
$p.bJ = (function(t) {
  return this.cAK((!(!t)));
});
var $d_Lpresto_ui_Inputs$$anon$3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_ui_Inputs$$anon$3, "presto.ui.Inputs$$anon$3", ({
  a3V: 1,
  K: 1
}));
export { $d_Lpresto_ui_Inputs$$anon$3 as $d_Lpresto_ui_Inputs$$anon$3 };
//# sourceMappingURL=presto.ui.-Inputs$$anon$3.js.map
